export const LONDON_AIRPORTS: Array<string> = ['LHR', 'LGW', 'STN', 'SEN', 'LTN', 'LCY'];
